export const GET_GEO_CHECKLIST = 'GET_GEO_CHECKLIST';
